import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";
export function useGitHubConnectionRepositorySourcingEnabled() {
    return useOctopusFeatureToggle("githubapp-git-resources", false) && isFeatureToggleEnabled("GitHubConnectionsFeatureToggle");
}
